export const COLORS = {
  HEALTH: "#47b247",
  FIREPOWER: "#f23d3d",
  RESILIENCE: "#3bbf16",
  SPEED: "#d766dd",
  PRECISION: "#e0d512",
  ENERGY: "#6acee5",
  FIREPOWER_PRECISION: "#e88827",
  PROPERTIES: "#95e8c0",
  ENHANCEMENTS: "#d3c47d",
  UNLOCKED: "#43fffa",
  LOCATION: "#d1d1d1",
  ONLINE_PLAYERS: "#39b77b",
  BASIC: "#999999",
  PILOTS: "#fcc11f",
  RATINGS: {
    PLATINUM: "#f2cdf7",
    GOLD: "#ffd731",
    SILVER: "#eeeeee",
    BRONZE: "#c68e5c",
  },
  TOOLTIP: "#ffffff",
  IMPORTANT: "#c92e39",
  TRAVEL: "#77c6ed",
  WARNING: "#ed2024",
  MOBS: "#ffb3b3",
  DISABLED: "#777777",
  RESTRICTED: "#FFC0CB",
};

export const FIGHT_DIALOG_STATUSES = ["openingDialog", "winDialog"];
